<mat-form-field>
  <mat-select [(value)]="selected"  (selectionChange)="valueSelected($event)">
  @for (item of range; track item) {
    <mat-option value="{{item}}">{{item}}</mat-option>
  }
</mat-select>
</mat-form-field>
